import React, { Component } from 'react';
import { Container, Draggable } from 'react-smooth-dnd';
import { Row, Col } from 'antd';
import DropZoneContainer from './DropZoneContainer';

class InterDraggableListView extends Component {
    render() {
        const { style = {}, shouldAcceptDrop = () => true, behaviour = "move", dragHandleSelector = undefined, groupName = "a", getChildPayload = () => { }, onDrop = () => { }, items = [], renderEmpty = () => { } } = this.props;

        const containerBahvior = (items.length === 0) ? "drop-zone" : behaviour
        return (
            <div >
                <Row>
                    <Col span={24} style={{ position: "relative" }}>
                        <DropZoneContainer style={{ ...style }} onDropReady={() => { }} behaviour={containerBahvior} dragHandleSelector={dragHandleSelector} getChildPayload={getChildPayload} shouldAcceptDrop={(sourceContainerOptions, payload) => {
                            return shouldAcceptDrop(sourceContainerOptions, payload)
                        }} groupName={groupName} onDrop={onDrop}>
                            {items.map((item, index) => {
                                return (
                                    <Draggable key={`${groupName}_${index}`}>
                                        {this.props.renderItem(item, index)}
                                    </Draggable>
                                );
                            })}
                        </DropZoneContainer>
                        {(items.length === 0) ? <div className="center-content" style={{ pointerEvents: "none", position: "absolute", width: "100%", height: "100%", top: 0, left: 0 }}>{renderEmpty()}</div> : null}
                    </Col>
                </Row>
            </div>
        );
    }
}

export default InterDraggableListView


// import React, { Component } from "react";
// import { Container, Draggable } from "react-smooth-dnd";
// // import { applyDrag, generateItems } from "./utils";

// const lorem = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
// Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
// Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`;

// const columnNames = ["Lorem", "Ipsum", "Consectetur", "Eiusmod"];

// const cardColors = [
//     "azure",
//     "beige",
//     "bisque",
//     "blanchedalmond",
//     "burlywood",
//     "cornsilk",
//     "gainsboro",
//     "ghostwhite",
//     "ivory",
//     "khaki"
// ];

// const applyDrag = (arr, dragResult) => {
//     const { removedIndex, addedIndex, payload } = dragResult;
//     if (removedIndex === null && addedIndex === null) return arr;

//     const result = [...arr];
//     let itemToAdd = payload;

//     if (removedIndex !== null) {
//         itemToAdd = result.splice(removedIndex, 1)[0];
//     }

//     if (addedIndex !== null) {
//         result.splice(addedIndex, 0, itemToAdd);
//     }

//     return result;
// };

// const generateItems = (count, creator) => {
//     const result = [];
//     for (let i = 0; i < count; i++) {
//         result.push(creator(i));
//     }
//     return result;
// };

// const pickColor = () => {
//     let rand = Math.floor(Math.random() * 10);
//     return cardColors[rand];
// };

// class InterDraggableViews extends Component {
//     constructor() {
//         super();

//         this.onColumnDrop = this.onColumnDrop.bind(this);
//         this.onCardDrop = this.onCardDrop.bind(this);
//         this.getCardPayload = this.getCardPayload.bind(this);
//         this.state = {
//             scene: {
//                 type: "container",
//                 props: {
//                     orientation: "horizontal"
//                 },
//                 children: generateItems(4, i => ({
//                     id: `column${i}`,
//                     type: "container",
//                     name: columnNames[i],
//                     props: {
//                         orientation: "vertical",
//                         className: "card-container"
//                     },
//                     children: generateItems(+(Math.random() * 10).toFixed() + 5, j => ({
//                         type: "draggable",
//                         id: `${i}${j}`,
//                         props: {
//                             className: "card",
//                             style: { backgroundColor: pickColor() }
//                         },
//                         data: lorem.slice(0, Math.floor(Math.random() * 150) + 30)
//                     }))
//                 }))
//             }
//         };
//     }

//     render() {
//         return (
//             <div className="card-scene">
//                 <Container
//                     orientation="horizontal"
//                     onDrop={this.onColumnDrop}
//                     dragHandleSelector=".column-drag-handle"
//                     dropPlaceholder={{
//                         animationDuration: 150,
//                         showOnTop: true,
//                         className: 'cards-drop-preview'
//                     }}
//                 >
//                     {this.state.scene.children.map(column => {
//                         return (
//                             <Draggable key={column.id}>
//                                 <div className={column.props.className}>
//                                     <div className="card-column-header">
//                                         <span className="column-drag-handle">&#x2630;</span>
//                                         {column.name}
//                                     </div>
//                                     <Container
//                                         {...column.props}
//                                         groupName="col"
//                                         onDragStart={e => console.log("drag started", e)}
//                                         onDragEnd={e => console.log("drag end", e)}
//                                         onDrop={e => this.onCardDrop(column.id, e)}
//                                         getChildPayload={index =>
//                                             this.getCardPayload(column.id, index)
//                                         }
//                                         dragClass="card-ghost"
//                                         dropClass="card-ghost-drop"
//                                         onDragEnter={() => {
//                                             console.log("drag enter:", column.id);
//                                         }}
//                                         onDragLeave={() => {
//                                             console.log("drag leave:", column.id);
//                                         }}
//                                         onDropReady={p => console.log('Drop ready: ', p)}
//                                         dropPlaceholder={{
//                                             animationDuration: 150,
//                                             showOnTop: true,
//                                             className: 'drop-preview'
//                                         }}
//                                         dropPlaceholderAnimationDuration={200}
//                                     >
//                                         {column.children.map(card => {
//                                             return (
//                                                 <Draggable key={card.id}>
//                                                     <div {...card.props}>
//                                                         <p>{card.data}</p>
//                                                     </div>
//                                                 </Draggable>
//                                             );
//                                         })}
//                                     </Container>
//                                 </div>
//                             </Draggable>
//                         );
//                     })}
//                 </Container>
//             </div>
//         );
//     }

//     getCardPayload(columnId, index) {
//         return this.state.scene.children.filter(p => p.id === columnId)[0].children[
//             index
//         ];
//     }

//     onColumnDrop(dropResult) {
//         const scene = Object.assign({}, this.state.scene);
//         scene.children = applyDrag(scene.children, dropResult);
//         this.setState({
//             scene
//         });
//     }

//     onCardDrop(columnId, dropResult) {
//         if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
//             const scene = Object.assign({}, this.state.scene);
//             const column = scene.children.filter(p => p.id === columnId)[0];
//             const columnIndex = scene.children.indexOf(column);

//             const newColumn = Object.assign({}, column);
//             newColumn.children = applyDrag(newColumn.children, dropResult);
//             scene.children.splice(columnIndex, 1, newColumn);

//             this.setState({
//                 scene
//             });
//         }
//     }
// }

// export default InterDraggableViews;